<template>
    <main class="operator-home">
        <header class="operator-home__header">{{ $t("Operator Mode") }}</header>

        <div class="operator-home__layout">
            <button class="operator-home__user" type="button" @click="redirectPage('change-account')">
                <b-avatar v-if="userData.photo" class="operator-home__avatar" variant="light-primary"
                    :src="userData.photo" />
                <b-avatar v-else variant="light-secondary" class="operator-home__avatar">
                    <span>{{ initials }}</span>
                </b-avatar>

                <strong>{{ fullName }}</strong>
                <span>{{ userData.job_role }}</span>
                <span>{{ userData.employee_id }}</span>
            </button>

            <section class="operator-home__actions" aria-label="Áreas do modo operador">
                <button type="button" class="operator-home__action" @click="openMenu('resources')">
                    <span class="operator-home__icon">
                        <ToolIcon />
                    </span>
                    <span>
                        <strong>Recursos</strong>
                        <small>Acesse recursos, favoritos e múltiplas ordens</small>
                    </span>
                    <ChevronRightIcon class="operator-home__chevron" />
                </button>

                <button type="button" class="operator-home__action" @click="openMenu('orders')">
                    <span class="operator-home__icon">
                        <FileTextIcon />
                    </span>
                    <span>
                        <strong>Ordens</strong>
                        <small>Consulte, acompanhe e agrupe ordens de produção</small>
                    </span>
                    <ChevronRightIcon class="operator-home__chevron" />
                </button>
            </section>
        </div>
    </main>
</template>

<script>
import { avatarText } from "@core/utils/filter";
import { BAvatar } from "bootstrap-vue";
import { ChevronRightIcon, FileTextIcon, ToolIcon } from "vue-feather-icons";
import { mapMutations } from "vuex";

export default {
    components: {
        BAvatar,
        ChevronRightIcon,
        FileTextIcon,
        ToolIcon
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("userData")) || {}
        };
    },
    computed: {
        fullName() {
            return [this.userData.first_name, this.userData.last_name].filter(Boolean).join(" ");
        },
        initials() {
            return avatarText(this.userData.first_name, this.userData.last_name);
        }
    },
    created() {
        this.UPDATE_FLAG_SHOW_OVERLAY(false);
        this.showMissingSiteWarning();
    },
    methods: {
        ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
        redirectPage(route) {
            const prefix = localStorage.getItem("prefix") || this.$route.params.prefix;
            this.$router.push({ path: `/${prefix}/${route}` });
        },
        openMenu(section) {
            this.$router.push({
                name: section === "resources" ? "operator-resources-menu" : "operator-orders-menu",
                params: { prefix: this.$route.params.prefix }
            });
        },
        showMissingSiteWarning() {
            const userInfo = this.$cookies.get("userInfo") || {};
            const sites = userInfo.userData?.sites || [];
            const loadingMySfc = this.$cookies.get("modalNoSites");

            if (sites.length > 0 || loadingMySfc?.mysfc) return;

            this.$swal({
                title: this.$t("ordersList.WarningTitle"),
                text: this.$t("ordersList.WarningText"),
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: true,
                customClass: { container: "swal-warning" }
            });

            const domain = window.location.href.includes("indsiders.com");
            this.$cookies.set(
                "modalNoSites",
                { mysfc: true, myconnect: false },
                null,
                null,
                domain ? "indsiders.com" : null
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.operator-home {
    min-height: calc(100vh - 110px);
    color: #4c4541;

    &__header {
        margin: -22px -28px 32px;
        padding: 16px 29px;
        background: #fff;
        border-top: 1px solid #cfc4be;
        box-shadow: 0 8px 30px rgba(58, 46, 38, 0.1);
        font-family: "Raleway";
        font-size: 22px;
        font-weight: 600;
    }

    &__layout {
        display: grid;
        grid-template-columns: minmax(260px, 34%) minmax(0, 1fr);
        gap: 22px;
        width: 100%;
    }

    &__user,
    &__action {
        border: 1px solid #cfc4be;
        background: #fafafa;
        box-shadow: 0 4px 24px rgba(58, 46, 38, 0.1);
        transition: background 0.2s, border-color 0.2s;

        &:hover,
        &:focus-visible {
            border-color: #974900;
            background: #ffede2;
            outline: none;
        }
    }

    &__user {
        min-height: 310px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;

        strong {
            margin-top: 18px;
            font-family: "Raleway";
            font-size: 24px;
        }

        span {
            color: #998f8a;
            font-size: 14px;
        }
    }

    &__avatar {
        width: 92px;
        height: 92px;
        font-size: 32px;
    }

    &__actions {
        display: grid;
        grid-template-rows: repeat(2, minmax(140px, 1fr));
        gap: 14px;
    }

    &__action {
        width: 100%;
        min-width: 0;
        border-radius: 8px;
        padding: 24px;
        display: grid;
        grid-template-columns: 54px minmax(0, 1fr) 24px;
        align-items: center;
        gap: 18px;
        text-align: left;
        color: inherit;

        strong,
        small {
            display: block;
        }

        strong {
            font-family: "Raleway";
            font-size: 22px;
            font-weight: 600;
        }

        small {
            margin-top: 5px;
            color: #998f8a;
            font-size: 13px;
        }
    }

    &__icon {
        width: 54px;
        height: 54px;
        border: 1px solid #974900;
        border-radius: 6px;
        display: grid;
        place-items: center;
        color: #974900;
    }

    &__chevron {
        color: #998f8a;
    }
}

@media (max-width: 768px) {
    .operator-home {
        &__header {
            margin-right: -16px;
            margin-left: -16px;
            padding: 14px 16px;
            font-size: 18px;
        }

        &__layout {
            grid-template-columns: 1fr;
        }

        &__user {
            min-height: 190px;
        }

        &__actions {
            grid-template-rows: none;
        }

        &__action {
            min-height: 116px;
            padding: 18px;

            strong {
                font-size: 18px;
            }
        }
    }
}
</style>
